import { render, staticRenderFns } from "./PosManagement.vue?vue&type=template&id=2d446c15"
import script from "./PosManagement.vue?vue&type=script&lang=js"
export * from "./PosManagement.vue?vue&type=script&lang=js"
import style0 from "./PosManagement.vue?vue&type=style&index=0&id=2d446c15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports